import { useMutation } from '@tanstack/react-query';
import { aiApi, ScribeResult } from '@/api/ai-api';

export interface ScribeInput {
  appointmentId: string;
  patientId: string;
  doctorId: string;
  transcript: Array<{ speaker: 'doctor' | 'patient' | 'system'; text: string; timestamp?: string }>;
}

export function useAIScribe() {
  return useMutation<ScribeResult, Error, ScribeInput>({
    mutationFn: async (payload: ScribeInput) => aiApi.generateSOAP(payload),
  });
}